<div class="main-container py-2">
  <div *ngIf="!isPdf">
    <img [src]="imgSrc" alt="" class="image" >
  </div>
  
  <div *ngIf="isPdf" class="w-100 h-100 d-flex justify-content-center">
    <iframe [src]="safeImgSrc" class="pdf-viewer" frameborder="0"></iframe>
  </div>
  <div class="close-btn-container d-flex">
    <ion-button *ngIf="!isLocalBlob" class="filled-blue-btn" (click)="downloadFile()">Download</ion-button>
    <ion-button class="close-btn unfilled-gray-btn" color="light" (click)="closeModal()"><ion-icon name="close-outline"></ion-icon></ion-button>
  </div>
</div>